import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { CommunityMemberMinimal } from "@/entities/IProfile";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { getSelectableIdentity } from "./getSelectableIdentity";
export default function CommonProfileSearchItem(t0) {
  const $ = _c(39);
  const {
    profile,
    selected,
    onProfileSelect,
    isHighlighted: t1,
    id
  } = t0;
  const isHighlighted = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== profile || $[1] !== selected) {
    const selectableValue = getSelectableIdentity(profile);
    t2 = typeof selectableValue === "string" && selected?.toLowerCase() === selectableValue.toLowerCase();
    $[0] = profile;
    $[1] = selected;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isSelected = t2;
  const title = profile.display ?? profile.handle ?? profile.wallet ?? "Profile";
  const avatarLabel = profile.display ?? profile.handle ?? profile.wallet ?? "Profile";
  const avatarAltText = `${avatarLabel} avatar`;
  let t3;
  if ($[3] !== profile.display || $[4] !== profile.handle || $[5] !== profile.wallet) {
    t3 = [profile.handle, profile.wallet, profile.display];
    $[3] = profile.display;
    $[4] = profile.handle;
    $[5] = profile.wallet;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3 || $[8] !== title) {
    t4 = t3.find(value => value && value !== title);
    $[7] = t3;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const secondaryText = t4;
  let t5;
  if ($[10] !== onProfileSelect || $[11] !== profile) {
    t5 = () => onProfileSelect(profile);
    $[10] = onProfileSelect;
    $[11] = profile;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const onProfileClick = t5;
  const visualItemId = `${id}-visual`;
  const t6 = `tw-h-full hover:tw-bg-iron-700 tw-py-2 tw-w-full tw-border-none tw-text-left tw-flex tw-items-center tw-justify-between tw-text-white tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-2 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out ${isHighlighted ? "tw-bg-iron-700" : "tw-bg-transparent"}`;
  let t7;
  if ($[13] !== avatarAltText || $[14] !== profile.pfp) {
    t7 = profile.pfp && <div className="tw-h-6 tw-w-6 tw-rounded-md tw-overflow-hidden tw-ring-1 tw-ring-inset tw-ring-white/10 tw-bg-iron-900"><div className="tw-h-full tw-w-full tw-max-w-full"><div className="tw-h-full tw-text-center tw-flex tw-items-center tw-justify-center"><img src={getScaledImageUri(profile.pfp, ImageScale.W_AUTO_H_50)} alt={avatarAltText} className="tw-bg-transparent tw-max-w-full tw-max-h-full tw-h-auto tw-w-auto tw-mx-auto tw-object-contain" /></div></div></div>;
    $[13] = avatarAltText;
    $[14] = profile.pfp;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== title) {
    t8 = <p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-white tw-truncate tw-whitespace-nowrap">{title}</p>;
    $[16] = title;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== secondaryText) {
    t9 = secondaryText && <p className="tw-mb-0 tw-text-xs tw-font-medium tw-text-iron-400 tw-truncate tw-whitespace-nowrap">{secondaryText}</p>;
    $[18] = secondaryText;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className="tw-w-[12rem] tw-truncate">{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t7) {
    t11 = <div className="tw-flex tw-space-x-2 tw-items-center">{t7}{t10}</div>;
    $[23] = t10;
    $[24] = t7;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== isSelected) {
    t12 = isSelected && <FontAwesomeIcon icon={faCheck} className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" aria-hidden="true" focusable={false} />;
    $[26] = isSelected;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <div className="tw-w-full tw-flex tw-justify-between tw-items-center">{t11}{t12}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13 || $[32] !== t6) {
    t14 = <div className={t6}>{t13}</div>;
    $[31] = t13;
    $[32] = t6;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== id || $[35] !== onProfileClick || $[36] !== t14 || $[37] !== visualItemId) {
    t15 = <li id={visualItemId} data-option-id={id} aria-hidden="true" className="tw-list-none" onClick={onProfileClick} tabIndex={-1}>{t14}</li>;
    $[34] = id;
    $[35] = onProfileClick;
    $[36] = t14;
    $[37] = visualItemId;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
}